var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialog,
        title: "导入Excel",
        width: _vm.getIsMobile ? "100%" : "50%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialog = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.upLoading,
              expression: "upLoading",
            },
          ],
          ref: "uploadInfoRef",
          attrs: {
            "label-position": "top",
            rules: _vm.rules,
            model: _vm.uploadInfo,
          },
        },
        [
          _c("div", { staticClass: "marginbottom" }, [
            _vm._v(
              "为减少上传错误，请下载案件导入模版后按照模版格式要求进行数据填写后再上传!"
            ),
          ]),
          _c(
            "el-link",
            {
              staticClass: "marginbottom",
              attrs: { type: "primary", icon: "el-icon-download" },
            },
            [
              _c(
                "a",
                { attrs: { target: "_blank" }, on: { click: _vm.handleDown } },
                [_vm._v("下载导入模板")]
              ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "文件上传" } },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    multiple: false,
                    drag: "",
                    limit: 1,
                    accept: ".xlsx, .xls",
                    action: _vm.action,
                    "on-success": _vm.uploadSuc,
                    "on-error": _vm.uploadFail,
                    "on-remove": _vm.cancelExcel,
                    "before-upload": _vm.beforeUpload,
                    "file-list": _vm.fileList,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      staticStyle: { "margin-top": "-12px", color: "red" },
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v(" 提示：仅允许导入“xls”或“xlsx”格式文件！ ")]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }